<template>
  <v-footer app class="mavFooter">
    <v-snackbar
        color="cyan"
        v-model="refreshPage"
        :bottom="'bottom'"
        :left="'left'"
        :timeout="timeout">
        <v-icon color="white" style="padding-right:10px">mdi-information-outline</v-icon>
        {{ refreshPageTxt }}
        <v-btn color="purple" flat @click="doRefreshPage()">
          Refresh
        </v-btn>
    </v-snackbar>
    <div class="hidden-sm-and-down">
      Copyright © {{ new Date().getFullYear() }} {{projectTitle}} All Rights Reserved. | <a :href="privUrl" target="_blank" class="pl-2">Privacy & Security</a>
    </div>
    <div class="hidden-md-and-up">
      Copyright © {{ new Date().getFullYear() }} {{projectShort}}. All Rights Reserved.
    </div>
    <v-spacer></v-spacer>
    <div class="hidden-sm-and-down">Powered by Odyssey 5 ({{appVersion}})</div>
  </v-footer>
</template>

<script>
import { AppInfoMixin } from '@/mixins/global/appInfo'

export default {
  // AR 01-Sep-2020: Refresh page to reset cache -- Start
  data: () => ({
    refreshPage: false,
    timeout: 30000,
    refreshPageTxt: 'A new Nimbus2 version is available.'
  }),
  mounted() {
    this.initVersionCheck()
  },
  methods: {
    initVersionCheck() {
      if (this.$store.state.token.token && this.$store.state.token.token !== '') {
        setInterval(() => {
          const apiURL = process.env.BASE_URL + 'appInfo/globalProps.json?t=' + new Date().getTime()
          this.getAppVersion(apiURL)
        }, this.intervalCheck)
      }
    },
    doRefreshPage() {
      this.refreshPage = false
      window.location.reload(true)
    },
    async getAppVersion(apiURL) {
      this.$http.get(apiURL).then((result) => {
        let appVersionNew = result.data.appInfo.appVersion
        if (appVersionNew !== this.appVersion && this.refreshPage === false && this.intervalCheck !== null) {
          console.log('New N2 version: ' + appVersionNew)
          console.log('Interval Value: ' + this.intervalCheck)
          window.localStorage.setItem('appVersion', appVersionNew)
          this.refreshPage = true
        }
      }).catch((err) => {
        console.log(err)
      })
    }
    // AR 01-Sep-2020: Refresh page to reset cache -- End
  },
  computed: {
    projectTitle() {
      return 'Premium Systems Technology Pte Ltd.  Co Reg No. 198103071K.'
    },
    projectShort() {
      return 'Premium.  Co Reg No. 198103071K.'
    },
    coyReg() {
      return process.env.VUE_APP_COYREG
    },
    privUrl() {
      if (process.env.VUE_APP_PRIVURL) {
        return process.env.VUE_APP_PRIVURL
      } else {
        return '/'
      }
    },
    // AR 01-Sep-2020: Refresh page to reset cache -- Start
    appVersion() {
      if (window.localStorage.getItem('appVersion')) {
        return window.localStorage.getItem('appVersion')
      } else {
        if (this.appInfo.appVersion) {
          return this.appInfo.appVersion
        } else {
          return 'N2.20010101'
        }
      }
    },
    intervalCheck() {
      if (this.appInfo.intervalCheck) {
        return this.appInfo.intervalCheck
      } else {
        return 30000
      }
    }
    // AR 01-Sep-2020: Refresh page to reset cache -- End
  },
  mixins: [
    AppInfoMixin
  ]
}
</script>

<style lang="scss">
.mavFooter {
  padding-left: 5px;
  padding-right: 5px;
  font-size: 0.9em;
}
</style>
